import {createReducer} from '../common';
import {
    SELECT_PLAN,
    GET_BT_TOKEN,
    SET_COUPON,
    SET_NONCE,
    SET_MENU,
    SET_DISCOUNTED_PRICE,
    APPLY_COUPON,
    SET_SHIPPING,
    GET_TRACKER_PRICING,
    SET_CAPTCHA_TOKEN,
} from 'actions/main';

const initState = {
    plan: 'default',
    coupon: '',
    isCouponApplied: false,
    btToken: '',
    nonce: '',
    paymentType: null,
    count: 1,
    price: null,
    initPrice: 79,
    isMenuShown: false,
    isShippingShown: false,
    countriesList: [],
    isConsentGiven: null
};

const setPricingData = (state, {payload}) => {

    const {
        price,
        initPrice,
        countriesList

    } = payload;

    return {
        ...state,
        price: price,
        initPrice: initPrice,
        countriesList: countriesList
    };
};

const selectPlan = (state, {payload}) => {
    return {...state, plan: payload};
};

const setBtToken = (state, {payload}) => {
    return {
        ...state,
        btToken: payload
    };
};

const setCoupon = (state, {payload}) => {
    return {
        ...state,
        coupon: payload
    };
};

const setApplied = (state, {payload}) => {
    const {isCouponApplied} = state;

    return {
        ...state,
        isCouponApplied: !isCouponApplied,
        ...payload
    };
};

const setNonce = (state, {payload}) => {

    const {type, nonce} = payload;
    return {
        ...state,
        nonce: nonce,
        paymentType: type,

    };
};

const setDiscount = (state, {payload}) => {
    return {
        ...state,
        price: payload
    };
};

const setMenu = (state, {payload}) => {

    return {
        ...state,
        isMenuShown: payload,
        ...payload,
    };
};

const setShipping = (state, {payload}) => {

    return {
        ...state,
        isShippingShown: payload,
        ...payload,
    };
};

const setConsentData = (state, {payload}) => {

    return {
        ...state,
        isConsentGiven: payload,
    };
};

const setCaptchaToken = (state, {payload}) => {

    const {type, token} = payload;

    if (type === 'braintree') {
        return {
            ...state,
            captchaTokenBrainTree: token,
        };
    }

    if (type === 'signup') {
        return {
            ...state,
            captchaTokenSignup: token,
        };
    }
};


const handlers = {
    [SELECT_PLAN]: selectPlan,
    [GET_BT_TOKEN.SUCCESS]: setBtToken,
    [SET_COUPON]: setCoupon,
    [SET_NONCE]: setNonce,
    [SET_MENU]: setMenu,
    [SET_DISCOUNTED_PRICE]: setDiscount,
    [APPLY_COUPON.SUCCESS]: setApplied,
    [SET_SHIPPING]: setShipping,
    [GET_TRACKER_PRICING.SUCCESS]: setPricingData,
    [SET_CAPTCHA_TOKEN]: setCaptchaToken,

};

export default createReducer(initState, handlers);
